import MyGroupFuneral from './GroupFuneral'

export default MyGroupFuneral